import { render, staticRenderFns } from "./LabelSwitch.vue?vue&type=template&id=d089fafa&"
import script from "./LabelSwitch.vue?vue&type=script&lang=js&"
export * from "./LabelSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LabelSwitch.vue?vue&type=style&index=0&id=d089fafa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports